import { render } from "./ESG.vue?vue&type=template&id=6b8e32cd&scoped=true"
import script from "./ESG.vue?vue&type=script&lang=js"
export * from "./ESG.vue?vue&type=script&lang=js"

import "./ESG.vue?vue&type=style&index=0&id=6b8e32cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8e32cd"]])

export default __exports__